import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Section } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Button } from './ui/Button';
import { Icon } from './ui/Icon';

export const Pricing = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <Section
      id="pricing"
      eyebrow={t.pricing.eyebrow}
      title={t.pricing.title}
      subtitle={t.pricing.subtitle}
      align="center"
      className="bg-elev"
    >
      <div className="grid lg:grid-cols-3 gap-5">
        {t.pricing.tiers.map((tier, i) => {
          const featured = !!tier.highlight;
          return (
            <Reveal key={tier.name} delay={100 * i}>
              <article
                className={`relative rounded-3xl border h-full p-7 flex flex-col ${
                  featured ? 'bg-app text-white shadow-lift' : 'bg-surface text-app'
                }`}
                style={{
                  borderColor: featured ? 'transparent' : 'var(--border)',
                  background: featured
                    ? 'linear-gradient(160deg, color-mix(in oklab, var(--brand) 90%, black) 0%, color-mix(in oklab, var(--brand) 55%, var(--accent)) 100%)'
                    : undefined,
                }}
              >
                {featured && (
                  <span className="absolute top-5 right-5 inline-flex items-center gap-1 rounded-full bg-white/15 backdrop-blur px-2.5 py-1 text-[0.65rem] font-semibold text-white uppercase tracking-[0.18em]">
                    <Icon name="sparkle" size={12} /> Recommended
                  </span>
                )}
                <h3 className={`text-display text-2xl font-bold ${featured ? 'text-white' : 'text-app'}`}>
                  {tier.name}
                </h3>
                <p className={`mt-1 text-sm ${featured ? 'text-white/80' : 'text-muted'}`}>
                  {tier.tagline}
                </p>
                <div className="mt-6 flex items-baseline gap-2">
                  <span className={`text-display text-4xl font-bold ${featured ? 'text-white' : 'text-app'}`}>
                    {tier.price}
                  </span>
                </div>

                <ul className="mt-7 space-y-3 flex-1">
                  {tier.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm">
                      <span
                        className={`mt-0.5 inline-flex items-center justify-center h-5 w-5 rounded-full shrink-0 ${
                          featured ? 'bg-white/20 text-white' : 'text-white'
                        }`}
                        style={!featured ? { background: 'var(--brand)' } : undefined}
                      >
                        <Icon name="check" size={12} />
                      </span>
                      <span className={featured ? 'text-white/90 leading-relaxed' : 'text-muted leading-relaxed'}>
                        {f}
                      </span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8">
                  <Button
                    onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                    variant={featured ? 'soft' : 'primary'}
                    className={`w-full justify-center ${featured ? '!bg-white !text-ink-900 hover:!bg-white' : ''}`}
                    icon={<Icon name="arrowRight" size={14} />}
                  >
                    {tier.cta}
                  </Button>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};

export default Pricing;
